"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPermissionCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "permission_Camera_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 9h18v15H7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.008 10h-6.016l-.728 2.2H10a2 2 0 00-2 2v6.794a2 2 0 002 2h12a2 2 0 002-2V14.2a2 2 0 00-2-2h-2.265l-.727-2.2zM20 17a4 4 0 11-8 0 4 4 0 018 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.992 10V9h-.722l-.227.686.95.314zm6.016 0l.95-.314L19.73 9h-.722v1zm-6.743 2.2v1h.722l.227-.686-.95-.314zm7.47 0l-.949.314.227.686h.722v-1zM12.992 11h6.016V9h-6.016v2zm.222 1.514l.728-2.2-1.9-.628-.727 2.2 1.899.628zm-.95-1.314H10v2h2.264v-2zM10 11.2a3 3 0 00-3 3h2a1 1 0 011-1v-2zm-3 3v6.794h2V14.2H7zm0 6.794a3 3 0 003 3v-2a1 1 0 01-1-1H7zm3 3h12v-2H10v2zm12 0a3 3 0 003-3h-2a1 1 0 01-1 1v2zm3-3V14.2h-2v6.794h2zm0-6.794a3 3 0 00-3-3v2a1 1 0 011 1h2zm-3-3h-2.265v2H22v-2zm-3.942-.886l.728 2.2 1.899-.628-.728-2.2-1.899.628zM16 22a5 5 0 005-5h-2a3 3 0 01-3 3v2zm-5-5a5 5 0 005 5v-2a3 3 0 01-3-3h-2zm5-5a5 5 0 00-5 5h2a3 3 0 013-3v-2zm5 5a5 5 0 00-5-5v2a3 3 0 013 3h2z",
    fill: props.color || "#343741",
    mask: "url(#permission_Camera_svg__a)"
  }));
}

var _default = SvgPermissionCamera;
exports["default"] = _default;